import "./style.scss";

import CloudOffIcon from "@mui/icons-material/CloudOff";
import FilterInput from "components/shared/FilterInput";
import { formatLocaleDateString } from "helpers/utils";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import type { IIntegrations } from "store/integrationsStore";
import type { IStatementTemplate } from "store/partnerStatementsStore";
import { getIntegrationAuthorName, isIntegrationActive } from "helpers/integrationHelpers";
import type { IUser } from "types";

import googleSheetIcon from "../../../assets/img/png/google-sheet-logo.png";

interface IGoogleTab {
    partnerStatements: IStatementTemplate[];
    integrations: IIntegrations[];
    users: IUser[];
    openStatementDrawer: (statementData: IStatementTemplate) => void;
}

const GoogleTab = ({ partnerStatements, integrations, users, openStatementDrawer }: IGoogleTab) => {
    const [t] = useTranslation();
    const [searchQuery, setSearchQuery] = useState("");

    const getIntegration = (integrationId: number) =>
        integrations.find((integration) => integration.id == integrationId);

    const filteredStatements = useMemo(() => {
        if (searchQuery) {
            return partnerStatements.filter((statement) =>
                statement.name.toLowerCase().includes(searchQuery.toLowerCase()),
            );
        } else {
            return partnerStatements;
        }
    }, [searchQuery, partnerStatements]);

    return (
        <div className="partner-statements-google-tab-list">
            <div className="statement-template-search">
                <FilterInput setFilterValue={setSearchQuery} filterValue={searchQuery} />
            </div>
            {filteredStatements.map((statement: IStatementTemplate) => {
                const integration = getIntegration(statement.integrationId);
                const isActive = isIntegrationActive(integration);
                return (
                    <div
                        className="statement-block"
                        key={`statement-${statement.id}`}
                        onClick={() => openStatementDrawer(statement)}
                    >
                        <div className="statement-block-left">
                            <div className={`statement-block-image ${!isActive ? "disconnected" : ""}`}>
                                <img src={googleSheetIcon} />
                                {!isActive && (
                                    <div className="disconnected-icon">
                                        <CloudOffIcon />
                                    </div>
                                )}
                            </div>
                            <div className="statement-block-left-text">
                                <span className="statement-name">{statement.name}</span>
                                <span className="block-info ">
                                    {`${t("PartnerStatements.EditedAt")} ${formatLocaleDateString({
                                        date: statement.modified ?? (statement.created as Date),
                                        options: { numeric: true, timeZone: "UTC" },
                                    })}`}
                                </span>
                            </div>
                        </div>
                        <div className="statement-block-right">
                            <span className="block-info ">{`${t(
                                "PartnerStatements.CreatedAt",
                            )} ${formatLocaleDateString({
                                date: statement.created as Date,
                                options: { numeric: true, timeZone: "UTC" },
                            })}`}</span>
                            {isActive && (
                                <span className="block-info ">
                                    {`${t(
                                        integration.accountEmail
                                            ? "PartnerStatements.GoogleAccount"
                                            : "PartnerStatements.AddedBy",
                                    )} ${getIntegrationAuthorName(integration, users, t)}`}
                                </span>
                            )}
                            {!isActive && (
                                <span className="block-info disconnected">{t("PartnerStatements.DesyncGoogle")}</span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default GoogleTab;
